import plugin from 'tailwindcss/plugin';

const noJsPlugin = plugin((_plugin) => {
  _plugin.addVariant('nojs', 'html.nojs &');
  _plugin.addVariant('js', 'html:not(.nojs) &');
});

export default noJsPlugin;
